type Props = {
  fillColor?: string;
  onClick?: () => void;
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
  onClick: () => {},
  disabled: false,
};
const ArrowUpIcon = function ArrowUpIcon(props: Props) {
  const { fillColor, onClick, disabled } = props;
  return (
    // <svg
    //   onClick={onClick}
    //   style={{ cursor: 'pointer' }}
    //   width="9"
    //   height="7"
    //   viewBox="0 0 9 7"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   className="arrow-up-icon"
    // >
    //   <path fill-rule="evenodd" clip-rule="evenodd" d="M4.51921 0.625L8.24728 6.59394H0.791138L4.51921 0.625Z" fill={fillColor} />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      onClick={onClick}
      opacity={disabled ? '0.5' : '1'}
      style={{ cursor: 'pointer' }}
      className="arrow-up-icon"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0L0 8L10 8L5 0Z" fill="#7E7E7E" />
    </svg>
  );
};
ArrowUpIcon.defaultProps = defaultProps;
export default ArrowUpIcon;
